import React from 'react';
import { AuditReport } from '../AuditReport';

export const AuditSummary = () => {
  return <AuditReport />;
};
